var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scheduling-investigation-page" },
    [
      _c("section", { staticClass: "investigation-console q-mb-md" }, [
        _c("div", { staticClass: "row gutter-md items-end" }, [
          _c(
            "div",
            { staticClass: "col-md-9 col-xs-12" },
            [
              _c(
                "q-field",
                {
                  attrs: {
                    error: Boolean(_vm.validationError),
                    "error-label": _vm.validationError,
                    "stack-label": "Inquiry IDs"
                  }
                },
                [
                  _c("q-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "18421, 18439, 18502"
                    },
                    on: {
                      keyup: [
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          if (!$event.ctrlKey) {
                            return null
                          }
                          return _vm.investigate($event)
                        },
                        function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          if (!$event.metaKey) {
                            return null
                          }
                          return _vm.investigate($event)
                        }
                      ]
                    },
                    model: {
                      value: _vm.inquiryIdsInput,
                      callback: function($$v) {
                        _vm.inquiryIdsInput = $$v
                      },
                      expression: "inquiryIdsInput"
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "input-hint" }, [
                _vm._v(
                  "\n          Separate IDs with commas, spaces, or new lines. Press Ctrl/⌘ + Enter to investigate.\n        "
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-3 col-xs-12" },
            [
              _c("q-btn", {
                staticClass: "full-width investigate-button",
                attrs: {
                  color: "primary",
                  icon: "search",
                  label: "Investigate",
                  "no-caps": "",
                  loading: _vm.loading
                },
                on: { click: _vm.investigate }
              })
            ],
            1
          )
        ])
      ]),
      _vm.hasResult
        ? [
            _vm.result.missing_inquiry_ids.length
              ? _c(
                  "section",
                  { staticClass: "missing-banner q-mb-md" },
                  [
                    _c("q-icon", { attrs: { name: "warning" } }),
                    _vm._v(
                      "\n      No inquiry was found for: " +
                        _vm._s(_vm.result.missing_inquiry_ids.join(", ")) +
                        "\n    "
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.result.diagnostics.length
              ? _c("section", { staticClass: "diagnostics-panel q-mb-md" }, [
                  _c("div", { staticClass: "section-label" }, [
                    _vm._v("\n        Diagnostic signals\n      ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "diagnostic-grid" },
                    _vm._l(_vm.result.diagnostics, function(diagnostic, index) {
                      return _c(
                        "div",
                        {
                          key:
                            diagnostic.type +
                            "-" +
                            diagnostic.entity_type +
                            "-" +
                            diagnostic.entity_id +
                            "-" +
                            index,
                          staticClass: "diagnostic-card",
                          class: "diagnostic-" + diagnostic.severity
                        },
                        [
                          _c("q-icon", {
                            attrs: {
                              name:
                                diagnostic.severity === "error"
                                  ? "error"
                                  : "warning"
                            }
                          }),
                          _c("span", [_vm._v(_vm._s(diagnostic.summary))])
                        ],
                        1
                      )
                    })
                  )
                ])
              : _vm._e(),
            _c("section", { staticClass: "timeline-panel" }, [
              _c("div", { staticClass: "timeline-toolbar" }, [
                _c("div", [
                  _c("div", { staticClass: "section-label" }, [
                    _vm._v("\n            Event timeline\n          ")
                  ]),
                  _c("div", { staticClass: "timeline-count" }, [
                    _vm._v(
                      "\n            Showing " +
                        _vm._s(_vm.filteredEvents.length) +
                        " of " +
                        _vm._s(_vm.result.events.length) +
                        " events\n          "
                    )
                  ]),
                  _vm.attributedInquiryIds.length
                    ? _c(
                        "div",
                        { staticClass: "inquiry-key" },
                        [
                          _vm._l(_vm.attributedInquiryIds, function(inquiryId) {
                            return _c(
                              "span",
                              {
                                key: inquiryId,
                                staticClass: "inquiry-key-item"
                              },
                              [
                                _c("i", {
                                  style: _vm.inquiryColorStyle(inquiryId)
                                }),
                                _vm._v(
                                  "\n              Inquiry #" +
                                    _vm._s(inquiryId) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          _vm.hasSharedEvents
                            ? _c("span", { staticClass: "inquiry-key-item" }, [
                                _c("i", { staticClass: "shared-key" }),
                                _vm._v("\n              Shared\n            ")
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ]),
                _c(
                  "div",
                  { staticClass: "filter-control" },
                  [
                    _c(
                      "div",
                      { staticClass: "timeline-options" },
                      [
                        _c("q-btn", {
                          staticClass: "copy-markdown-button",
                          attrs: {
                            dense: "",
                            flat: "",
                            "no-caps": "",
                            icon: "content_copy",
                            label: "Copy all as Markdown"
                          },
                          on: { click: _vm.copyMarkdown }
                        }),
                        _c("q-toggle", {
                          attrs: {
                            label: "Only failures and anomalies",
                            color: "negative"
                          },
                          model: {
                            value: _vm.onlyAnomalies,
                            callback: function($$v) {
                              _vm.onlyAnomalies = $$v
                            },
                            expression: "onlyAnomalies"
                          }
                        })
                      ],
                      1
                    ),
                    _c("q-select", {
                      attrs: {
                        options: _vm.result.event_types,
                        multiple: "",
                        chips: "",
                        filter: "",
                        "stack-label": "Event types"
                      },
                      model: {
                        value: _vm.selectedEventTypes,
                        callback: function($$v) {
                          _vm.selectedEventTypes = $$v
                        },
                        expression: "selectedEventTypes"
                      }
                    }),
                    _c("div", { staticClass: "filter-actions" }, [
                      _c(
                        "button",
                        {
                          attrs: { type: "button" },
                          on: { click: _vm.selectAllEventTypes }
                        },
                        [_vm._v("\n              Select all\n            ")]
                      ),
                      _c("span", [_vm._v("/")]),
                      _c(
                        "button",
                        {
                          attrs: { type: "button" },
                          on: { click: _vm.clearEventTypes }
                        },
                        [_vm._v("\n              Clear\n            ")]
                      )
                    ])
                  ],
                  1
                )
              ]),
              _vm.filteredEvents.length
                ? _c(
                    "div",
                    { staticClass: "event-list" },
                    _vm._l(_vm.filteredEvents, function(event) {
                      return _c(
                        "article",
                        {
                          key: event.id,
                          staticClass: "event-row",
                          class: [
                            "event-" + event.type.replace(".", "-"),
                            _vm.eventSeverity(event)
                              ? "event-" + _vm.eventSeverity(event)
                              : "",
                            {
                              "is-expanded": _vm.isExpanded(event.id),
                              "is-inquiry-specific":
                                event.inquiry_ids &&
                                event.inquiry_ids.length === 1,
                              "is-shared-event":
                                event.inquiry_ids &&
                                event.inquiry_ids.length > 1
                            }
                          ],
                          style: _vm.eventInquiryStyle(event)
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "event-header",
                              attrs: {
                                type: "button",
                                "aria-expanded": _vm.isExpanded(event.id)
                                  ? "true"
                                  : "false"
                              },
                              on: {
                                click: function($event) {
                                  _vm.toggleEvent(event.id)
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "event-marker" }),
                              _c("span", { staticClass: "event-time" }, [
                                _vm._v(_vm._s(event.occurred_at))
                              ]),
                              _c("span", { staticClass: "event-separator" }, [
                                _vm._v("—")
                              ]),
                              _c("span", { staticClass: "event-summary" }, [
                                _vm._v(_vm._s(event.summary))
                              ]),
                              _c("span", { staticClass: "event-type" }, [
                                _vm._v(_vm._s(_vm.eventTypeLabel(event.type)))
                              ]),
                              _c("q-icon", {
                                staticClass: "event-toggle",
                                attrs: {
                                  name: _vm.isExpanded(event.id)
                                    ? "keyboard_arrow_up"
                                    : "keyboard_arrow_down"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.isExpanded(event.id)
                            ? _c("div", { staticClass: "event-details" }, [
                                _c("div", { staticClass: "details-column" }, [
                                  _c("div", { staticClass: "details-label" }, [
                                    _vm._v(
                                      "\n                Event data\n              "
                                    )
                                  ]),
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(_vm.formatJson(event.details))
                                    )
                                  ])
                                ]),
                                _c("div", { staticClass: "details-column" }, [
                                  _c("div", { staticClass: "details-label" }, [
                                    _vm._v(
                                      "\n                Related context · current state\n              "
                                    )
                                  ]),
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(_vm.formatJson(event.context))
                                    )
                                  ])
                                ])
                              ])
                            : _vm._e()
                        ]
                      )
                    })
                  )
                : _c(
                    "div",
                    { staticClass: "empty-state" },
                    [
                      _c("q-icon", { attrs: { name: "filter_list" } }),
                      _c("strong", [
                        _vm._v("No events match the current filters.")
                      ]),
                      _vm.onlyAnomalies
                        ? _c("span", [
                            _vm._v(
                              "No failures or anomalies match the selected event types."
                            )
                          ])
                        : _vm.result.events.length
                        ? _c("span", [
                            _vm._v(
                              "Select one or more event types to restore the timeline."
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              "No dated events were found for this inquiry graph."
                            )
                          ])
                    ],
                    1
                  )
            ])
          ]
        : _vm.apiError
        ? _c(
            "section",
            { staticClass: "error-state" },
            [
              _c("q-icon", { attrs: { name: "error_outline" } }),
              _c("div", [
                _c("strong", [_vm._v("Investigation failed")]),
                _c("p", [_vm._v(_vm._s(_vm.apiError))])
              ])
            ],
            1
          )
        : _c("section", { staticClass: "initial-state" }, [
            _c(
              "div",
              { staticClass: "initial-orbit" },
              [_c("q-icon", { attrs: { name: "device_hub" } })],
              1
            ),
            _c("strong", [_vm._v("Start with an inquiry ID")]),
            _c("span", [
              _vm._v(
                "\n      The graph will reveal scheduling attempts and Nylas responses, shared schedules, related leads,\n      notifications, showing profiles and their assignee pools, tours, device access code attempts, and Showami logs.\n    "
              )
            ])
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }